@if (claimPolicy$ | async) {
<div>
  @if ( !!lossVehicle?.policyPosition && policyVehicleInfo) {
  <div class="flex justify-between" style="align-items: center">
    <div class="flex" style="align-items: center">
      <div class="cui-h3">Policy Vehicle:</div>
      <span class="screen-reader-only">Policy Vehicle</span>
      <cla-vehicle class="vehicle" [vehicle]="policyVehicleInfo"></cla-vehicle>
    </div>
  </div>
  } @else { @if ((isLoading$ | async) === false) {
  <cui-empty-state
    data-pgr-id="no-policy-vehicle"
    icon="search"
    primaryText="No policy vehicle coverages have been selected."
  >
  </cui-empty-state>
  } }
</div>
} @else {
<cui-empty-state
  data-pgr-id="no-policy-found"
  icon="search"
  primaryText="An active policy was not found for the date of loss."
>
</cui-empty-state>
}
